<template>
  <div>
    <v-notification>
    </v-notification>
    <div class="activation-history__title">
      <img src="/img/svg/common/document-check.svg" alt=""/>
      <h1>{{ getLocalization('Provider statistic') }}</h1>
    </div>
    <div class="--all provider-statistic-wrapper d-flex provider-static-wrap">
      <div class="activation-history-all">
        <div class="activation-history-all__mobile-content activation-history-all__mobile-content-provider">
          <div
              id="activation-history-all-filter-provider"
              class="activation-history-all__filter show"
          >
            <base-table
                :columns="this.columns"
                table-class="vgt-table activation-history-all__table new-design-table"
                :render-list-to-show="this.listToShow"
                :wrapperFiltersData="this.wrapperFiltersData"
                :per-page-default="perPage"
                :table-title="null"
                :accept-filters-button-label="getLocalization('Apply filters')"
                new-design-class="activation-history-partner__body provider-statistic-max-height"
            >
              <template v-slot:base-table-row="props">
                <td v-if="props.column.field === 'delivery'">
                  {{ props.formattedRow[props.column.field] }} %
                </td>
                <td v-else-if="props.column.field === 'price'">
                  {{ props.formattedRow[props.column.field] }}₽
                </td>
                <td v-else-if="props.column.field === 'agent_id'">
                  {{ getLocalization('Provider') }} {{ props.formattedRow[props.column.field] }}
                </td>
                <td v-else-if="props.column.field === 'buy'">
                  <button v-if="props.formattedRow.price > 0 && props.row.count > 0" class="button primary" @click="buyPhoneNumber(props.row.price, props.row.country_code, props.row.service_code, props.row.agent_id)">{{ getLocalization('Buy') }}</button>
                  <div v-else>
                    {{ getLocalization('Out of stock now') }}
                  </div>
                </td>
                <template v-else>
                  <td>{{ props.formattedRow[props.column.field] }}</td>
                </template>
              </template>
            </base-table>
          </div>
        </div>
        <div class="activation-history-all__items" style="height: 400px; overflow: auto">
          <div class="activation-history-all-card" v-for="stat in providerStatisticList">
            <div class="--item --row --flex-1">
              <div class="--label">{{ getLocalization('Provider') }}</div>
              <div class="--value">{{ getLocalization('Provider') }} {{ stat['agent_id'] }}</div>
            </div>
            <div class="--divider"></div>
            <div class="--item">
              <div class="--label">{{ getLocalization('Country') }}</div>
              <div class="--value">{{ stat['country'] }}</div>
            </div>
            <div class="--item">
              <div class="--label">{{ getLocalization('Service') }}</div>
              <div class="--value">{{ stat['service'] }}</div>
            </div>
            <div class="--divider"></div>
            <div class="--item">
              <div class="--label">{{ getLocalization('Success rate') }}</div>
              <div class="--value">{{ stat['delivery'] }} %</div>
            </div>
            <div class="--item">
              <div class="--label">{{ getLocalization('Price') }}</div>
              <div class="--value">{{ stat['price'] }} ₽</div>
            </div>
            <div class="--divider"></div>
            <div class="--item">
              <div class="--value">
                <button v-if="stat['price'] > 0 && stat['count'] > 0" class="button primary" @click="buyPhoneNumber(stat.price, stat.country_code, stat.service_code, stat.agent_id)">{{ getLocalization('Buy') }}</button>
                <div v-else>{{ getLocalization('Out of stock now') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="loaded" class="d-flex justify-content-between flex-wrap" style="height: 400px">
        <BarChart
            :width="400"
            :height="400"
            chart-id="providerStatistic"
            :chart-data="chartData"
        ></BarChart>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import WrapperFiltersComponent from "../../../components/table/wrapperFilters.vue";
import BaseSendRequestMixin from "../../../components/mixins/BaseSendRequestMixin.vue";
import BaseMessagingMixin from "../../../components/mixins/BaseMessagingMixin.vue";
import BaseTable from "../../../components/table/baseTable.vue";
import BarChart from "../../../components/LineChart/barChart.vue";
import GraphDynamic from "../../../components/mixins/GraphDynamicMixin";

export default {
  name: "phoneHistory",
  mixins: [
    BaseSendRequestMixin,
    BaseMessagingMixin,
    GraphDynamic
  ],
  components: {
    BarChart,
    BaseTable,
    Multiselect,
    WrapperFiltersComponent
  },
  props: [
    'providers',
    'phoneHistoryRoute'
  ],
  data: function () {
    return {
      wrapperFiltersData: {
        title: this.getLocalization('Activations history'),
        filtersUrl: '/cabinet/client/providerstatistic/getList',
        showResetFilterButton: true,
        showCollapseFilter: true,
        newDesign: true,
        items: {
          provider: {
            enable: true,
            multiple: true,
            placeholder: this.getLocalization('Provider'),
            className: '--provider-item fs-5',
            data: this.providers,
            needLocalization: true
          },
          countries: {
            enable: true,
            getDataLink: '/countries/getList',
            selectedKey: 'countryId',
            placeholder: this.getLocalization('Country'),
            viewLabel: 'title',
            className: '--provider-item --provider-item-double',
            closeOnSelect: true,
            needLocalization: true,
            noGroupSelect: true,
          },
          services: {
            enable: true,
            getDataLink: '/services/getList',
            placeholder: this.getLocalization('Service'),
            viewLabel: 'title',
            selectedKey: 'serviceId',
            closeOnSelect: true,
            className: '--provider-item',
            noGroupSelect: true,
          },
          delivery: {
            enable: true,
            selectedKey: 'delivery',
            placeholder: this.getLocalization('Success rate'),
            className: '--provider-item --provider-item-small',
            closeOnSelect: true,
            needLocalization: true,
            noGroupSelect: true,
            data: [
              {
                id: 5,
                title: '<=5'
              },
              {
                id: 10,
                title: '<=10'
              },
              {
                id: 15,
                title: '<=15'
              },
              {
                id: 30,
                title: '<=30'
              },
              {
                id: 45,
                title: '<=45'
              },
              {
                id: 60,
                title: '<=60'
              },
              {
                id: 75,
                title: '<=75'
              },
              {
                id: 90,
                title: '<=90'
              },
              {
                id: 100,
                title: '<=100'
              },
            ],
          },
          price: {
            enable: true,
            selectedKey: 'price',
            placeholder: this.getLocalization('Price'),
            className: '--provider-item fs-5',
            closeOnSelect: true,
            noGroupSelect: true,
            needLocalization: true,
            data: [
              {
                id: 5,
                title: '<=5'
              },
              {
                id: 20,
                title: '<=20'
              },
              {
                id: 50,
                title: '<=50'
              },
              {
                id: 80,
                title: '<=80'
              },
              {
                id: 100,
                title: '<=100'
              },
              {
                id: 150,
                title: '<=150'
              },
              {
                id: 200,
                title: '<=200'
              }
            ],
          },
          date: {
            enable: true,
            dateFromText: this.getLocalization('Date from'),
            dateToText: this.getLocalization('Date to'),
            className: '--provider-items',
          },
        }
      },
      perPage: 50,
      columns: [
        {
          label: this.getLocalization('Provider'),
          field: 'agent_id',
          sortable: false,
          width: '20%'
        },
        {
          label: this.getLocalization('Country'),
          field: 'country',
          sortable: false,
          width: '20%'
        },
        {
          label: this.getLocalization('Service'),
          sortable: false,
          field: 'service',
          width: '16%'
        },
        {
          label: this.getLocalization('Success rate'),
          field: 'delivery',
          type: 'number',
          sortable: true,
          width: '14%'
        },
        {
          label: this.getLocalization('Price'),
          field: 'price',
          width: '10%',
          type: 'number',
        },
        {
          label: this.getLocalization('Buy'),
          field: 'buy',
          width: '10%',
          sortable: false,
        },
      ],
      chartData: {
        datasets: [],
        labels: []
      },
      loaded: false,
      providerStatisticList: []
    }
  },
  methods: {
    listToShow(list) {
      let data = [];
      for (let elem of list) {
        data.push({
          service: elem['service_variation']['service']['title'],
          service_code: elem['service_variation']['service']['activate_org_code'],
          country: elem['service_variation']['country']['title'],
          country_code: elem['service_variation']['country']['activate_org_code'],
          price: elem['price'],
          delivery: elem['delivery'],
          agent_id: elem['agent_id'],
          count: elem['count']
        });
      }
      this.prepareChartData(data);
      this.providerStatisticList = data;
      return data;
    },
    prepareChartData(data) {
      this.chartData = {
        datasets: [],
        labels: []
      };

      if (data.length < 1) {
        return;
      }
      const topFive = data.slice(0, 5);

      let deliveryData = [];
      let labels = [];

      for (let barEl of topFive) {
        let label = this.getLocalization('Provider') + ' ' + barEl['agent_id'];

        labels.push(label);
        deliveryData.push(barEl['delivery']);
      }
      let dataset = {
        label: this.getLocalization('Success rate'),
        data: deliveryData,
        backgroundColor: [],
        borderColor: [],
        borderWidth: 1,
        borderRadius: 7
      };

      for (let i = 0; i < 5; i++) {
        dataset.backgroundColor.push(this.DATA_SET_COLORS[i].backgroundColor);
        dataset.borderColor.push(this.DATA_SET_COLORS[i].borderColor);
      }

      this.chartData.datasets.push(dataset);
      this.chartData.labels = labels;

      this.loaded = true;
    }

    ,
    async buyPhoneNumber(maxPrice, countryCode, serviceCode = null, providerIds = null) {
      let data = {
        action: 'getNumber',
        service: serviceCode ?? this.selectedService.activate_org_code,
        country: countryCode,
        fixPrice: maxPrice,
        ...(providerIds && {providerIds})
      }
      let getNumber = await this.sendRequest('/web/stubs/handler_api.php', 'get', data);
      if (getNumber.includes('ACCESS_NUMBER')) {
        await this.alertMessage(this.getLocalization('Done. You’ve gotten a number!'), 'info');
        setTimeout(() => {
          window.location.href = this.phoneHistoryRoute;
        }, 1000);
      } else if (getNumber.includes('NO_NUMBERS')) {
        await this.alertMessage(this.getLocalization('No numbers available yet'), 'error');
      } else if (getNumber.includes('NO_BALANCE')) {
        await this.alertMessage(this.getLocalization('No balance. Please top up your balance'), 'error');
      }

    },
  },
}
</script>
